import React, { useEffect, useState } from 'react';
import { adminListDonations, adminDeleteDonation } from '../../lib/api';
import { Loader2, Heart, Trash2, Mail } from 'lucide-react';
import { useToast } from '../../hooks/use-toast';

export default function AdminDonations() {
  const [donations, setDonations] = useState(null);
  const { toast } = useToast();

  const load = () => adminListDonations().then(setDonations);
  useEffect(() => { load(); }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer ce don ?')) return;
    await adminDeleteDonation(id);
    toast({ title: 'Supprimé' });
    load();
  };

  if (!donations) return <div className="p-10"><Loader2 className="w-6 h-6 animate-spin text-sky-500" /></div>;

  const total = donations.reduce((sum, d) => sum + (d.amount || 0), 0);

  return (
    <div className="p-8 lg:p-10">
      <header className="mb-6 flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="font-display font-extrabold text-3xl text-sky-950">Dons reçus</h1>
          <p className="text-slate-500 mt-1">{donations.length} don{donations.length > 1 ? 's' : ''}</p>
        </div>
        <div className="bg-gradient-to-r from-sky-500 to-emerald-500 rounded-2xl px-5 py-3 text-white">
          <p className="text-xs uppercase tracking-wider opacity-80">Total collecté</p>
          <p className="font-display font-extrabold text-2xl">{total.toLocaleString('fr-FR')} €</p>
        </div>
      </header>

      {donations.length === 0 ? (
        <div className="bg-white rounded-2xl border border-sky-100 p-16 text-center">
          <Heart className="w-12 h-12 text-sky-200 mx-auto mb-3" />
          <p className="text-slate-500">Aucun don pour le moment.</p>
        </div>
      ) : (
        <div className="bg-white rounded-2xl border border-sky-100 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-sky-50/60 text-xs uppercase tracking-wider text-slate-600">
              <tr>
                <th className="text-left px-5 py-3 font-semibold">Donateur</th>
                <th className="text-left px-5 py-3 font-semibold">Email</th>
                <th className="text-left px-5 py-3 font-semibold">Type</th>
                <th className="text-right px-5 py-3 font-semibold">Montant</th>
                <th className="text-left px-5 py-3 font-semibold">Date</th>
                <th className="px-5 py-3"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-sky-50">
              {donations.map((d) => (
                <tr key={d.id} className="hover:bg-sky-50/40">
                  <td className="px-5 py-3 font-semibold text-sky-950">{d.name}</td>
                  <td className="px-5 py-3"><a href={`mailto:${d.email}`} className="text-sky-700 hover:underline inline-flex items-center gap-1"><Mail className="w-3 h-3" />{d.email}</a></td>
                  <td className="px-5 py-3"><span className={`px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider ${d.frequency === 'monthly' ? 'bg-purple-50 text-purple-700' : 'bg-emerald-50 text-emerald-700'}`}>{d.frequency === 'monthly' ? 'Mensuel' : 'Unique'}</span></td>
                  <td className="px-5 py-3 text-right font-display font-extrabold text-sky-950">{d.amount} €</td>
                  <td className="px-5 py-3 text-slate-500 text-xs">{new Date(d.createdAt).toLocaleDateString('fr-FR')}</td>
                  <td className="px-5 py-3 text-right">
                    <button onClick={() => handleDelete(d.id)} className="p-2 rounded-lg hover:bg-rose-50 text-rose-500"><Trash2 className="w-4 h-4" /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
